import {
  Button, Card, CardActions, CardContent, Divider, Modal
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScanSettings } from 'scandit-sdk';
import BarcodePicker from './BarcodePicker';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  content: {
    height: 600,
    overflowY: 'auto',
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));


function BarkodPopupModal({
  open, onClose, customer, className, ScanTime, ...rest
}) {
  const classes = useStyles();
  const { t } = useTranslation('common');
  if (!open) {
    return null;
  }

  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <form>
          <CardContent className={classes.content}>
            <BarcodePicker
              // guiStyle={"viewfinder"}
              playSoundOnScan
              vibrateOnScan
              enableTorchToggle
              enablePinchToZoom
              enableTapToFocus
              enableCameraSwitcher
              // accessCamera={false}
              // camera={undefined}
              scanSettings={
                new ScanSettings({
                  enabledSymbologies: ['code128', 'QR'],
                  codeDuplicateFilter: parseInt(ScanTime),
                  gpuAcceleration: true,
                  blurryRecognition: true
                })
              }
              onScan={(e) => onClose(e.barcodes[0].data)}
              onError={console.log}
            />
          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              color="primary"
              onClick={onClose}
            >
              {t('Kapat')}
            </Button>

          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

BarkodPopupModal.propTypes = {
  className: PropTypes.string,
  customer: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

BarkodPopupModal.defaultProps = {
  open: false,
  onClose: () => { }
};

export default BarkodPopupModal;
